import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "mailToEmail"
})
export class MailToEmailPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): string {
    return `mailto:${value}`;
  }

}
